var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 6C2.5 3.79086 4.29086 2 6.5 2H18.5C20.7091 2 22.5 3.79086 22.5 6V12.449L20.2535 10.9786C18.519 9.84327 16.2486 9.96391 14.6442 11.2766L9.406 15.5624C8.30825 16.4606 6.75482 16.5431 5.56808 15.7663L2.5 13.7581V6ZM19.432 12.2336L22.5 14.2418V18C22.5 20.2091 20.7091 22 18.5 22H6.5C4.29086 22 2.5 20.2091 2.5 18V15.5509L4.74659 17.0214C6.48106 18.1567 8.75145 18.036 10.3559 16.7233L15.5941 12.4375C16.6918 11.5394 18.2452 11.4568 19.432 12.2336ZM9 11C10.3807 11 11.5 9.88071 11.5 8.5C11.5 7.11929 10.3807 6 9 6C7.61929 6 6.5 7.11929 6.5 8.5C6.5 9.88071 7.61929 11 9 11Z",
    fill: "#515B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageRectangle);
export default __webpack_public_path__ + "static/media/image-rectangle.8b880af7ce2770cfcb29169163f4565e.svg";
export { ForwardRef as ReactComponent };